import type { TCreditFormCommonFields } from 'entities/creditForm';
import { defaultStepperConfigSelector, selectAllFormFields } from 'entities/creditForm';

import { recalculateSteps } from './stepper';

export const submitAnketaThunk =
  (isDialog: boolean | undefined, onFullySubmitCallback: (data: TCreditFormCommonFields) => void): ThunkResult<void> =>
  async (_, getState) => {
    const formFields = selectAllFormFields(getState());

    const { activeStep } = recalculateSteps(defaultStepperConfigSelector(getState()));
    if (!isDialog && activeStep?.stepIndex === undefined) {
      onFullySubmitCallback(formFields);
    }
  };
